import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import Clienti from './components/Clienti';
import Fornitori from './components/Fornitori';
import SelezionePersonale from './components/SelezionePersonale';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/clienti" element={<Clienti />} />
          <Route path="/fornitori" element={<Fornitori />} />
          <Route path="/selezione-personale" element={<SelezionePersonale />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
